import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import PDFViewer from './pdf-viewer';

const enhance = compose(
	withState('numPages', 'setNumPages', 0),
	withHandlers({
		onDocumentLoadSuccess: ({onLoadListener, setNumPages}) => pdf => {
			setNumPages(pdf.numPages);
			if (onLoadListener) {
				onLoadListener(pdf);
			}
		}
	})
);

export default enhance(PDFViewer);



// WEBPACK FOOTER //
// ./src/client/components/main/files/pdf-viewer/index.js